import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * MetricCard — displays a headline metric with an optional real computed delta.
 * Now accepts `delta` (a number) + `deltaLabel` instead of hardcoded trend strings.
 */
const MetricCard = ({ label, value, delta, deltaLabel, icon, trend, trendValue, color = "emerald" }) => {
    const isEmerald = color === "emerald";
    
    // Support new delta-based or legacy trend-based props
    const hasDelta = delta !== undefined && delta !== null;
    const isPositive = hasDelta ? delta >= 0 : true;
    const displayDelta = hasDelta
      ? `${delta >= 0 ? '+' : ''}${typeof delta === 'number' && !Number.isInteger(delta) ? delta.toFixed(1) : delta}${deltaLabel || ''}`
      : trendValue;

    const showBadge = hasDelta || trendValue;

    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-100 relative overflow-hidden group hover:border-emerald-200 transition-all duration-300">
            {/* Background Glow */}
            <div className={`absolute top-0 right-0 w-24 h-24 ${isEmerald ? 'bg-emerald-500/5' : 'bg-slate-500/5'} rounded-full -mr-12 -mt-12 blur-2xl group-hover:blur-3xl transition-all duration-700`} />
            
            <div className="relative z-10 flex flex-col h-full justify-between">
                <div>
                    <p className="text-xs font-medium tracking-[0.2em] text-slate-900 mb-6">{label}</p>
                    <div className="flex items-end justify-between">
                        <h3 className="text-2xl font-medium text-slate-900 tracking-tight">{value}</h3>

                        
                        {showBadge && (
                            <div className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border ${
                                hasDelta
                                  ? (isPositive
                                    ? 'bg-emerald-50 text-emerald-600 border-emerald-100'
                                    : 'bg-rose-50 text-rose-600 border-rose-100')
                                  : (isEmerald 
                                    ? 'bg-emerald-50 text-emerald-600 border-emerald-100' 
                                    : 'bg-slate-50 text-slate-500 border-slate-100')
                            }`}>
                                {hasDelta ? (
                                  <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={12} className="stroke-[3]" />
                                ) : (
                                  <>
                                    {trend === 'up' && <Icon name="TrendingUp" size={12} className="stroke-[3]" />}
                                    {trend === 'time' && <Icon name="Clock" size={12} className="stroke-[3]" />}
                                    {trend === 'check' && <Icon name="CheckCircle2" size={12} className="stroke-[3]" />}
                                  </>
                                )}
                                <span className="text-[11px] font-medium">{displayDelta}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MetricCard;
